import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class PortalAuthEndpoint {
    private readonly http = inject(HttpClient);

    private readonly endpoints = {
        logout: 'auth/logout'
    };

    logout(): Observable<void> {
        return this.http.post<void>(this.endpoints.logout, null);
    }
}
